<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section epub:type="bodymatter chapter" id="chapter01">
<p class="dedication"><a id="page-v"></a><em>This book is for my sisters: Heather, Linda and Nathalie.</em></p>
<p class="dedication1"><em>I could list the reasons why, but that would be a book in itself.</em></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?35043e72